const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/snackbar.ts';
import { MessageDescriptor } from 'react-intl';
import { ColorSettings, Severity } from 'App/components/utils';
import { v4 as uuidv4 } from 'uuid';
import { PATAPP_ADD_SNACKBAR, PATAPP_REMOVE_SNACKBAR } from './ui';

export type typeSnackbarActionPayload = {
    color?: ColorSettings | Severity;
    id: string;
    message: MessageDescriptor;
    autoHideDuration?: number;
    canAddMultiple?: boolean;
};

export type AddSnackbarAction = {
    type: string;
    payload: typeSnackbarActionPayload;
};

export type RemoveSnackbarAction = {
    type: string;
    payload: { id: string };
};

export function addSnackbar(
    color: ColorSettings | Severity = 'info',
    message: MessageDescriptor,
    autoHideDuration?: number,
    canAddMultiple: boolean = true // Prevent snackbar spamming (check that message.id and color is not already added)
): AddSnackbarAction {
    return {
        type: PATAPP_ADD_SNACKBAR,
        payload: {
            color,
            message,
            id: uuidv4(),
            autoHideDuration,
            canAddMultiple: canAddMultiple,
        },
    };
}

export function removeSnackbar(id: string): RemoveSnackbarAction {
    return {
        type: PATAPP_REMOVE_SNACKBAR,
        payload: {
            id,
        },
    };
}
